<div class="math-wrapper">
  <span #mathField></span>
</div>